export default {"src":"/_next/static/media/ic-twitch.ff3d65eb.svg","height":32,"width":31};